import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_offline-forms/farm-mapping')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_offline-forms/farm-mapping"!</div>
}
